var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{attrs:{"type":_vm.type,"form-columns":_vm.formColumns,"form":_vm.form,"title":_vm.$t('changePassword'),"onFetchData":_vm.onFetchData,"onFormSubmit":_vm.onFormSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }